import { ToggleGroup, ToggleGroupItem } from "../../ui/toggle-group";
import { cn } from "../../utils/common/cn";

/** Realized = matured cohorts (every contract has run off), Projected = active cohorts
 *  (contracts still on the books). */
export type Basis = "realized" | "projected";
/** Basis plus a third "Active" button, offered when the page passes `activeHint`. */
export type ThreeWayBasis = Basis | "active";

export function BasisToggle<B extends ThreeWayBasis = Basis>({
  value,
  onChange,
  className,
  realizedHint = "Matured cohorts: every contract has run off",
  projectedHint = "Active cohorts: contracts still on the books",
  projectedLabel = "Projected",
  activeHint,
}: {
  value: B;
  onChange: (next: NoInfer<B>) => void;
  className?: string;
  realizedHint?: string;
  projectedHint?: string;
  /** The text on the second button (the value stays "projected"): a page that calls these cohorts something else, e.g. "Active". */
  projectedLabel?: string;
  /** Adds a third "Active" button with this tooltip, for a page that splits Projected from Active cohorts. */
  activeHint?: string;
}) {
  return (
    <ToggleGroup
      type="single"
      value={value}
      onValueChange={(next) => next && onChange(next as B)}
      className={cn("border border-border bg-secondary", className)}
      aria-label="Basis"
    >
      <ToggleGroupItem
        value="realized"
        className="h-9 px-3 text-xs"
        title={realizedHint}
      >
        Realized
      </ToggleGroupItem>
      <ToggleGroupItem
        value="projected"
        className="h-9 px-3 text-xs"
        title={projectedHint}
      >
        {projectedLabel}
      </ToggleGroupItem>
      {activeHint && (
        <ToggleGroupItem
          value="active"
          className="h-9 px-3 text-xs"
          title={activeHint}
        >
          Active
        </ToggleGroupItem>
      )}
    </ToggleGroup>
  );
}
